export default "/2.c54c2f51973f8de002bf82a31161f3ff.png";